// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --background: #ffffff;
    --foreground: #000000;

    /* Primary colors */
    --color-orange: #f76902;
    /* use white or #FFFFFF for white */

    /* Secondary colors */
    /* use black or #000000 for black */
    --color-gray-1: #d0d3d4;
    --color-gray-2: #a2aaad;
    --color-gray-3: #7c878e;
    --color-warm-gray-1: #d7d2cb;
    --color-warm-gray-2: #aca39a;

    /* Accent colors */
    --color-green: #84bd00;
    --color-yellow-green: #c4d600;
    --color-blue: #009cbd;
    --color-purple: #7d55c7;
    --color-red: #da291c;
    --color-yellow: #f6be00;
}

@media (prefers-color-scheme: dark) {
    :root {
        --background: #000000;
        --foreground: #ffffff;
    }
}

* {
    box-sizing: border-box;
}

html,
body {
    width: 100%;
    overflow-x: hidden;
}

header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 4em;
    z-index: 100;
    padding: 0 1.5em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    color: black;
    box-shadow: 0em 0.5rem 1em rgba(0, 0, 0, 0.1);
}

.banner {
    top: 4.25em;
    width: 100%;
    background-color: var(--color-orange); /* or you may use --color-yellow */
    padding: 1em;
    font-weight: 700;
}

body {
    margin: 0; /* Removes default body margin */
    background: var(--background);
    color: var(--foreground);
    font-family: "Helvetica Neue", "Helvetica", "Roboto", "Arial", sans-serif;
}

main {
    margin: 1.5rem;
    max-width: calc(100% - 3rem);
}


footer {
    width: 100%;
    height: 5rem;
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: #212121;
    color: white;
}



.smalltext {
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-weight: 300;
}


html, body, #root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

html, body, #root {
  height: 100%;
}

#root {
  display: flex;
  flex-direction: column;
}


/* If you have a main layout wrapper, make it stable */
.app-root, .app-container, .page-container {
  min-height: 100%;
}

/* Prevent resize jitter in scrolling areas */
.main-content, .content, .outlet-wrapper {
  min-height: 0;         /* critical for flex children */
  overflow: auto;
}

mark {
    padding: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;;IAErB,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;;IAEnC,qBAAqB;IACrB,mCAAmC;IACnC,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;;IAE5B,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI;QACI,qBAAqB;QACrB,qBAAqB;IACzB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,WAAW;IACX,qCAAqC,EAAE,kCAAkC;IACzE,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,SAAS,EAAE,gCAAgC;IAC3C,6BAA6B;IAC7B,wBAAwB;IACxB,yEAAyE;AAC7E;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;AAChB;;;;AAIA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA,sDAAsD;AACtD;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa,UAAU,+BAA+B;EACtD,cAAc;AAChB;;AAGE;IAAA,uBAAA;AAAU","sourcesContent":[":root {\n    --background: #ffffff;\n    --foreground: #000000;\n\n    /* Primary colors */\n    --color-orange: #f76902;\n    /* use white or #FFFFFF for white */\n\n    /* Secondary colors */\n    /* use black or #000000 for black */\n    --color-gray-1: #d0d3d4;\n    --color-gray-2: #a2aaad;\n    --color-gray-3: #7c878e;\n    --color-warm-gray-1: #d7d2cb;\n    --color-warm-gray-2: #aca39a;\n\n    /* Accent colors */\n    --color-green: #84bd00;\n    --color-yellow-green: #c4d600;\n    --color-blue: #009cbd;\n    --color-purple: #7d55c7;\n    --color-red: #da291c;\n    --color-yellow: #f6be00;\n}\n\n@media (prefers-color-scheme: dark) {\n    :root {\n        --background: #000000;\n        --foreground: #ffffff;\n    }\n}\n\n* {\n    box-sizing: border-box;\n}\n\nhtml,\nbody {\n    width: 100%;\n    overflow-x: hidden;\n}\n\nheader {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    height: 4em;\n    z-index: 100;\n    padding: 0 1.5em;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: white;\n    color: black;\n    box-shadow: 0em 0.5rem 1em rgba(0, 0, 0, 0.1);\n}\n\n.banner {\n    top: 4.25em;\n    width: 100%;\n    background-color: var(--color-orange); /* or you may use --color-yellow */\n    padding: 1em;\n    font-weight: 700;\n}\n\nbody {\n    margin: 0; /* Removes default body margin */\n    background: var(--background);\n    color: var(--foreground);\n    font-family: \"Helvetica Neue\", \"Helvetica\", \"Roboto\", \"Arial\", sans-serif;\n}\n\nmain {\n    margin: 1.5rem;\n    max-width: calc(100% - 3rem);\n}\n\n\nfooter {\n    width: 100%;\n    height: 5rem;\n    box-sizing: border-box;\n    padding: 0 1.5rem;\n    background-color: #212121;\n    color: white;\n}\n\n\n\n.smalltext {\n    font-size: 0.875rem;\n    line-height: 1.5rem;\n    font-weight: 300;\n}\n\n\nhtml, body, #root {\n  height: 100%;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  height: 100%;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n}\n\n\n/* If you have a main layout wrapper, make it stable */\n.app-root, .app-container, .page-container {\n  min-height: 100%;\n}\n\n/* Prevent resize jitter in scrolling areas */\n.main-content, .content, .outlet-wrapper {\n  min-height: 0;         /* critical for flex children */\n  overflow: auto;\n}\n\nmark {\n  @apply !p-0\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
